import { Link, Navigate } from 'react-router'
import { PATHS } from '@/app/router/routes'
import { Button } from '@/shared/ui/button'
import { TypographyParagraph } from '@/shared/ui/typography/paragraph'
import LayoutAuth from '../components/layout-auth'
import useAuth from '../hooks/use-auth'

export function ForgotPasswordSuccess() {
  const { auth } = useAuth()

  if (auth?.id) return <Navigate to={PATHS.admin.root} replace />

  return (
    <LayoutAuth
      title="Correo electrónico enviado"
      description="Si existe una cuenta activa con ese correo, recibirás un enlace válido por 30 minutos."
    >
      <TypographyParagraph>
        Revisa también la carpeta de correo no deseado. Por seguridad, esta pantalla no confirma si
        la cuenta existe.
      </TypographyParagraph>
      <Button asChild variant="link">
        <Link to={PATHS.auth.login}>Iniciar sesión</Link>
      </Button>
    </LayoutAuth>
  )
}
